const TermsOfService = () => (
  <div className="max-w-3xl mx-auto px-4 py-10">
    <h1 className="text-2xl font-bold mb-6 text-center">利用規約</h1>

    <p className="mb-4">
      本利用規約（以下「本規約」）は、当ブログ（以下「当サイト」）の閲覧および利用に関する条件を定めるものです。ご利用にあたっては、本規約に同意いただいたものとみなします。
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. 利用について</h2>
    <p className="mb-2">
      当サイトは、情報提供を目的としたブログです。どなたでも無料で閲覧いただけますが、将来的に一部機能やコンテンツを限定・有料化する可能性があります。
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. 禁止事項</h2>
    <ul className="list-disc pl-6 mb-2 text-gray-700">
      <li>当サイトの内容を無断転載・改変・営利目的で利用する行為</li>
      <li>著作権その他権利を侵害する行為</li>
      <li>他の利用者や第三者に不利益を与える行為</li>
      <li>スパム・迷惑行為・サイト運営を妨げる行為</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. 免責事項</h2>
    <p className="mb-2">
      当サイトに掲載されている情報は、正確性や信頼性を保証するものではありません。内容によって生じた損害等について、当サイト運営者は一切責任を負いません。
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. 外部リンクについて</h2>
    <p className="mb-2">
      当サイトには外部サイトへのリンクが含まれる場合がありますが、リンク先の内容については一切責任を負いません。
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. 規約の変更</h2>
    <p className="mb-2">
      本規約は、必要に応じて予告なく変更されることがあります。変更後も引き続き当サイトを利用された場合、変更に同意したものとみなします。
    </p>

    <p className="mt-6 text-sm text-gray-500">制定日：2025年6月13日</p>
  </div>
);

export default TermsOfService;